export const RA_MORNINGSTAR = 'b2041576-c507-47b5-8c08-b4fddba65a64';
export const RA_MORNINGSTAR_DBRS = '1f435932-7d91-4c8d-9369-c040327aaf9b';

export const HIDDEN_RATING_AGENCY_IDS: string[] = [RA_MORNINGSTAR];
